import { render, staticRenderFns } from "./ChannelLogoCmp.vue?vue&type=template&id=5ee98d0f&scoped=true&"
import script from "./ChannelLogoCmp.vue?vue&type=script&lang=js&"
export * from "./ChannelLogoCmp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelLogoCmp.vue?vue&type=style&index=0&id=5ee98d0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee98d0f",
  null
  
)

export default component.exports